// playground.ts — zod schema for the dashboard playground's chat body (spec D6/D9, M3
// task-5). `sessionKey` is optional: the route defaults it to `pg-{userId}` when omitted.
import { z } from 'zod';

export const playgroundChatSchema = z.object({
  message: z.string().min(1).max(2000),
  sessionKey: z.string().min(1).max(100).optional(),
});
